module.exports = __webpack_public_path__ + "assets/51e76b0ac54f274747101eaf272c9235.png";